import React from 'react';
import { FacebookIcon, Greyscale } from 'glints-aries';
import styled from 'styled-components';

import useConfig from 'src/common/hooks/useConfig';
import { getSocialMediaUrl } from 'src/components/links/SocialMediaLink';
import { device } from 'src/styles/components/screenSize';

const OnboardingFooter = () => {
  const { country } = useConfig({
    country: 'COUNTRY',
  });
  const socialMediaLink = getSocialMediaUrl(country);

  return (
    <StyledFooter>
      <Left>
        <p>&copy; Glints Pte Ltd</p>
      </Left>

      <Right>
        <StyledLink
          target="_blank"
          rel="noopener noreferrer"
          href="https://assets.glints.com/docs/GlintsTermsAndConditions.pdf"
        >
          Terms & Privacy
        </StyledLink>
        <StyledLink
          target="_blank"
          // https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
          rel="noopener noreferrer"
          href={socialMediaLink.facebook}
        >
          <FacebookIcon color="#cbcbcb" width="15px" height="15px" />
        </StyledLink>
      </Right>
    </StyledFooter>
  );
};

const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 300;
  border-top: solid 1px #cbcbcb;
  margin: 0 auto;
  width: 77%;

  @media ${device.tablet} {
    visibility: hidden;
  }
`;

const Left = styled.div`
  margin: 9px 0;
  color: #cbcbcb;
`;

const Right = styled.div`
  margin: 9px 0;
  color: #cbcbcb;
`;

const StyledLink = styled.a`
  color: #cbcbcb;
  outline: none;
  margin-left: 20px;

  :hover {
    color: ${Greyscale.black};
  }

  i {
    margin-right: 0;
  }
`;

export default OnboardingFooter;
